import * as core from '../../../../../../../core'

import { query } from './award-details.query'

export const RESOURCE = {
  payload: {
    alias: 'sr:award-details',
    content: {
      segments: [
        {
          alias: 'info',
          name: 'Info',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'sr.award-details.widgets.info',
                    },
                  },
                },
              },
            ],
          },
        },
        {
          alias: 'projects',
          name: 'Projects',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'sr.award-details.widgets.projects-table',
                    },
                  },
                },
              },
            ],
          },
        },
      ],
      navigator: core.mosaic.Page.Segment.Navigator.Tabs,
    },
    description: 'Award Details',
    name: 'Award Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
